import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/auth/AuthProvider";
import { Spinner } from "@/components/ui";

// Gates the authenticated area. While the initial /auth/me check is in flight we
// show a spinner; a guest is redirected to /login (preserving where they were
// headed). Server 403s on individual routes remain the real authorization
// boundary; this is just the session gate.
export function ProtectedRoute() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div className="grid h-dvh place-items-center bg-bg text-muted">
        <Spinner size={28} />
      </div>
    );
  }
  if (status === "guest") {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
}
